export default {
  createSuccess: "Verkäufer erfolgreich erstellt!",
  createModal: {
    title: "Neuen Verkäufer hinzufügen",
    namePlaceholder: "z. B. Acme Tours",
    emailPlaceholder: "verkaeufer@beispiel.de",
    create: "Verkäufer erstellen",
  },
  detail: {
    loadSeller: "Verkäuferdetails werden geladen...",
    loadError: "Verkäufer konnte nicht geladen werden",
    roleLabel: "Verkäufer",
    statActivities: "Aktivitäten",
    bookingsCardTitle: "Buchungen",
    seeBookings: "Buchungen anzeigen",
    toastPasswordResetSent:
      "E-Mail zum Zurücksetzen des Passworts an den Verkäufer gesendet.",
    activitiesTitle: "Aktivitäten ({{count}})",
    addActivity: "Aktivität hinzufügen",
    loadActivities: "Aktivitäten werden geladen...",
    activitiesError: "Aktivitäten konnten nicht geladen werden",
    noActivitiesTitle: "Keine Aktivitäten",
    noActivitiesDesc: "Dieser Verkäufer hat noch keine Aktivitäten",
    toastStatusUpdated: "Verkäuferstatus aktualisiert",
    toastStatusError: "Verkäuferstatus konnte nicht aktualisiert werden",
    categoryRestaurant: "Restaurant",
    categoryService: "Service",
    categoryAttraction: "Erlebnis",
    activityCommission: "Provision",
  },
} as const;
